/* unplugin-vue-components disabled */import script from "./Load.vue?vue&type=script&lang=ts&setup=true"
export * from "./Load.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__